import { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Select,
  MenuItem,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
} from "@mui/material";
import { ChangeCircle } from "@mui/icons-material";
import useFetch from "hooks/useFetch";
import { useRuns } from "contexts/RunsContext";
import usePage from "hooks/usePage";

export default function ChangeProjectMenuItem({ onClick, run }) {
  const [open, setOpen] = useState(false);
  const { patchRun } = useRuns();
  const { projectId } = usePage();
  const { data: projectRes } = useFetch("/project");
  const { data: customerRes } = useFetch("/customer");
  const [selectedProjectId, setSelectedProjectId] = useState(null);
  const [selectedCustomerId, setSelectedCustomerId] = useState(null);

  useEffect(() => {
    const project = projectRes?.projects?.find((p) => p.id === projectId);
    if (project) {
      setSelectedCustomerId(project.customer_id);
    }
  }, [projectRes, projectId]);

  const onCancel = () => {
    setOpen(false);
  };

  const onSave = () => {
    setOpen(false);
    patchRun(run.id, "project_id", selectedProjectId);
  };

  return (
    <>
      <MenuItem
        onClick={(e) => {
          e.stopPropagation();
          onClick(); // close the run menu dropdown
          setOpen(true);
        }}
      >
        <ChangeCircle sx={{ mr: 1 }} fontSize="small" />
        Change Project
      </MenuItem>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle>Change Project</DialogTitle>
        <DialogContent>
          <FormControl
            variant="standard"
            sx={{ width: "100%", marginBottom: "5px" }}
          >
            <Select
              value={selectedCustomerId}
              onChange={(e) => setSelectedCustomerId(e.target.value)}
              label="Select customer"
            >
              {(customerRes?.customers || []).map((customer) => (
                <MenuItem
                  key={customer.id}
                  value={customer.id}
                  selected={selectedCustomerId === customer.id}
                >
                  {customer.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl variant="standard" sx={{ width: "100%" }}>
            <InputLabel id="select-project-label">Select project</InputLabel>
            <Select
              labelId="select-project-label"
              id="select-project"
              value={selectedProjectId}
              onChange={(e) => setSelectedProjectId(e.target.value)}
              label="Select project"
            >
              {(
                projectRes?.projects?.filter(
                  (p) => p.customer_id === selectedCustomerId
                ) || []
              ).map((project) => (
                <MenuItem
                  key={project.id}
                  value={project.id}
                  selected={selectedProjectId === project.id}
                >
                  {project.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={onCancel}>Cancel</Button>
          <Button onClick={onSave} disabled={!selectedProjectId}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
